import { TableDataQa } from 'commons/types/enums'
import { SortDirection, Table as TableComponent } from 'ui/components'
import { useDeleteDocumentConfirmation } from '~bank-documents/hooks/useDeleteDocumentConfirmation'

import { useDocumentsListContext } from '../../context/DocumentsListContext'
import { columns } from './columns'

export const Table = () => {
  const { data, isPending, search, invalidate, onFilterChange, onPageChange } = useDocumentsListContext()

  const { DeleteConfirmation, openDeleteDocumentConfirmation: onDocumentDelete } = useDeleteDocumentConfirmation({
    onSuccess: () => {
      invalidate()
    }
  })

  return (
    <>
      <DeleteConfirmation />
      <TableComponent
        dataQa={TableDataQa.BP_DOCUMENTS_LIST_V2}
        loading={isPending}
        columns={columns({ onDocumentDelete, sortFields: data?.sortFields })}
        dataSource={data?.items.map((item) => ({ item }))}
        pagination={{
          page: search.page || 1,
          size: search.size || 10,
          onChange: (page: number, size: number) => onPageChange(page, size),
          total: data?.total
        }}
        sorting={{
          order: [{ field: search?.sortBy || data.sortFields[0], direction: search?.sortDesc ? 'DESC' : 'ASC' }],
          onChange: (value) =>
            onFilterChange({ sortBy: value.field, sortDesc: value.direction === SortDirection.DESC, page: 1 })
        }}
      />
    </>
  )
}
